import axios from "axios";
import HttpRequestService from "../services/HttpRequestService";
import baseUrl from "../utilities/baseUrl";

const token = localStorage.getItem("token");

export async function getMethod(url, params = {}, signal = undefined) {
  try {
    const furl = baseUrl + url;

    const response = await axios.get(furl, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      params: { ...params },
      signal,
    });
    return response.data;
  } catch (error) {
    return HttpRequestService.handleReturnValue(error).data;
  }
}

export async function postMethod(url, body, options = {}) {
  const furl = baseUrl + url;

  const data = await axios
    .post(furl, body, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      ...options,
    })
    .catch(function (error) {
      return HttpRequestService.handleReturnValue(error);
    });

  return data;
}

export async function getRequestByAuth(url) {
  try {
    const furl = baseUrl + url;

    const data = await axios.get(furl, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
    });

    return data.data;
  } catch (error) {
    HttpRequestService.handleUnauthorized(error);
    return HttpRequestService.handleReturnValue(error).data;
  }
}

export async function postRequestByAuth(url, body, formData = false) {
  const furl = baseUrl + url;

  const data = await axios
    .post(furl, body, {
      headers: {
        Accept: "application/json",
        "Content-Type": formData
          ? "multipart/form-data"
          : "application/json;charset=UTF-8",

        Authorization: "Bearer " + token,
      },
    })
    .catch(function (error) {
      HttpRequestService.handleUnauthorized(error);
      return HttpRequestService.handleReturnValue(error);
    });

  return data;
}

export async function putRequestByAuth(url, body, formData = false) {
  const furl = baseUrl + url;

  const data = await axios
    .put(furl, body, {
      headers: {
        Accept: "application/json",
        "Content-Type": formData
          ? "multipart/form-data"
          : "application/json;charset=UTF-8",

        Authorization: "Bearer " + token,
      },
    })
    .catch(function (error) {
      HttpRequestService.handleUnauthorized(error);
      return HttpRequestService.handleReturnValue(error);
    });

  return data;
}

export function handleEnter(event) {
  if (event.key === "Enter") {
    const form = event.target.form;
    const index = [...form].indexOf(event.target);
    form[index + 1].focus();
    event.preventDefault();
  }
}

export async function getService(url, params = {}) {
  try {
    const response = await axios.get(baseUrl + url, {
      params: params,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
    });

    return response;
  } catch (error) {
    return HttpRequestService.handleReturnValue(error);
  }
}

export async function getByAuthService(url, params = {}) {
  try {
    const response = await axios.get(baseUrl + url, {
      params: params,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
    });

    return response;
  } catch (error) {
    HttpRequestService.handleUnauthorized(error);
    return HttpRequestService.handleReturnValue(error);
  }
}

export async function downloadFileWithAuth(url, params = {}) {
  try {
    const response = await axios.get(baseUrl + url, {
      headers: {
        Authorization: "Bearer " + token,
      },
      params,
      responseType: "blob",
    });

    const href = URL.createObjectURL(response.data);

    const date = new Date();
    const time = [
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
    ].join("");

    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", "file_" + time);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(href);

    return { status: response.status };
  } catch (error) {
    HttpRequestService.handleUnauthorized(error);
    return HttpRequestService.handleReturnValue(error);
  }
}
